import React from 'react'
import sensor from '../assets/sensor.jpg'
import motion from '../assets/motion.jpg'
import disaster from '../assets/disaster_response.jpg'
import rl from '../assets/rl.jpg'
import diesel from '../assets/diesel.jpg'
import advimg from '../assets/advancedimg.jpg'
import real_time_object from '../assets/real_time_object.jpg'
import image_cap from "../assets/image_cap.jpg"
const Project = () => {

  const projects=[
    {
      id:1,
      src:image_cap,
      url:"https://github.com/Hussain7252/Image-Narrative-From-Conventional-to-Cutting-Edge-Captioning",
      info:"https://sites.google.com/husky.neu.edu/hussain-kanchwala/image-captioning",
      title:"Image Narrative: From Conventional to Cutting Edge Captioning"
    },
    {
      id:2,
      src:real_time_object,
      url:"https://github.com/Hussain7252/Object_Recognition",
      info:"https://sites.google.com/husky.neu.edu/hussain-kanchwala/real-time-object-recognition",
      title:"Real-Time Object Recognition"
    },
    {
      id:3,
      src:advimg,
      url:"https://github.com/Hussain7252/Advanced-Image-filtering-and-Feature-Matching",
      info:"https://sites.google.com/husky.neu.edu/hussain-kanchwala/image-analysis-implementing-filters-with-feature-detection-and-matching",
      title:"Advanced Image Filtering and Feature Matching"
    },
    {
      id:7,
      src:rl,
      url:"https://github.com/Hussain7252/RL_Prodigy",
      info:"https://sites.google.com/husky.neu.edu/hussain-kanchwala/reinforcement-learning",
      title:"RL Prodigy: Mastering Reinforcement Learning"
    },
    {
      id:4,
      src: disaster,
      url:"https://github.com/Hussain7252/Mobile_Robot_Disresp",
      info:"https://sites.google.com/husky.neu.edu/hussain-kanchwala/autonomous-reconnaissance",
      title:"Autonomous Disaster Response & Reconnaissance using TurtleBot 3"
    },
    {
      id:5,
      src:motion,
      url:"https://github.com/Hussain7252/Motion_Planning",
      info:"https://sites.google.com/husky.neu.edu/hussain-kanchwala/motion-planning",
      title:"Path Planner Odyssey:A* to Pure Pursuit with PRM,RRT and RRT*"
    },
    {
      id:6,
      src: sensor,
      url:"https://github.com/Hussain7252/Sensor-Fusion-for-Dead-Reckoning",
      info:"https://sites.google.com/husky.neu.edu/hussain-kanchwala/sensor-fusion-and-dead-reckoning",
      title:"Sensor Fusion for Dead Reckoning"
    },
    {
      id:8,
      src:diesel,
      url:"https://github.com/Hussain7252/Hinf_fuelinjection_control",
      info:"https://sites.google.com/husky.neu.edu/hussain-kanchwala/hinf-fuel-injection-control",
      title:"H-Infinty Automotive Diesel Engine Fuel Injector Control"
    },
  ]

  const openUrlInNewTab = (url) => {
    window.open(url, '_blank');
  };

  return (
    <div name="projects" className="bg-gradient-to-b  from-black to-gray-800 w-full h-auto py-20 text-white md:h-auto">
      <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full">
        <div className="pb-8">
          <p className="text-4xl font-bold inline border-b-4 border-gray-500">Projects</p>
          <p className="py-6 ">Check out some of my work right here</p>
        </div>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-8 px-12 sm:px-0">
        {
          projects.map(({id,src,url,info,title})=>(
            <div key={id} className="shadow-md shadow-gray-600 rounded-lg h-auto">
            <img src={src} alt="pjimage" className="rounded-md w-80 h-32 duration-200 hover:scale-105"/>
            <div className="flex items-center justify-center">
              <p className='px-6 py-3 text-gray-300 font-bold'>{title}</p>
            </div>
            <div className="flex items-center justify-center">
              <button className="w-1/2 px-6 py-3 m-4 rounded-md bg-gradient-to-r from-cyan-500 to-blue-500 duration-200 hover:scale-105" onClick={() => openUrlInNewTab(url)}>Code</button>
              <button className="w-1/2 px-6 py-3 m-4 rounded-md bg-gradient-to-r from-cyan-500 to-blue-500 duration-200 hover:scale-105" onClick={() => openUrlInNewTab(info)}>Info</button>
            </div>
          </div>
          ))
        }
        </div>
      </div>
    </div>
  )
}

export default Project